<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('tooltypes') }} </h3>

        <span></span>
    </div>

    <div class="card-component">
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="10"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox style="width: 230px;"
                    (valueChange)="onFilter($event)">
                </kendo-textbox>
                <kendo-grid-spacer></kendo-grid-spacer>
                <button [hidden]="!canEdit()" kendoButton icon="add" [title]="customMsgService.translate('btnCriar')"
                    (click)="open()" themeColor="primary">

                </button>

                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">

                </button>

                <!-- <button kendoGridExcelCommand type="button"  icon="file-csv" themeColor="warning">
          
                </button> -->
                <button kendoGridPDFCommand type="button" icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>


            <kendo-grid-column field="serial" title=" " [width]="50">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <app-image [idImage]="dataItem.refImagem"></app-image>
                    <!-- <div class="tool-photo" [ngStyle]="{ 'background-image': photoURL(dataItem) }"></div> -->
                    <!-- <div class="customer-name"> {{ dataItem.serial }} </div> -->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="nome" [title]="customMsgService.translate('name')" [width]="120">
            </kendo-grid-column>

            <kendo-grid-column field="descricaoTamanho" [title]="customMsgService.translate('size')" [width]="140">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <!-- <div class="customer-photo" [ngStyle]="{ 'background-image': photoURL(dataItem) }"></div> -->
                    <div class="customer-name"> {{ getSize(dataItem) }} </div>
                </ng-template>
            </kendo-grid-column>



            <kendo-grid-column field="avariasDesccricao" [title]="customMsgService.translate('listaDeAvarias')"
                [width]="220">

                <ng-template kendoGridCellTemplate let-dataItem>
                    <!-- <div class="customer-photo" [ngStyle]="{ 'background-image': photoURL(dataItem) }"></div> -->
                    <div class="customer-name"> {{ dataItem.avarias?.join(', ') }} </div>
                </ng-template>

            </kendo-grid-column>
            <kendo-grid-column field="obs" [title]="customMsgService.translate('obs')" [width]="220">
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="45"  [hidden]="!canEdit()" >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="copy" [title]=""
                        (click)="copyEdit(dataItem)" [primary]="true"></button>

                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="45" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [title]="customMsgService.translate('btnEditar')"
                        (click)="openEdit(dataItem)" [primary]="true"></button>

                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="" [width]="45" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                        (click)="delete(dataItem)" themeColor="error"></button>

                </ng-template>
            </kendo-grid-column>




            <kendo-grid-pdf fileName="{{customMsgService.translate('tooltypes')}}.pdf" [repeatHeaders]="true" [allPages]="true" paperSize="A4"
                [landscape]="true" [scale]="0.6" [delay]="2000">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('tooltypes') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{ customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>
                <kendo-grid-column field="serial" title=".....">
                   
                </kendo-grid-column>
                <kendo-grid-column field="nome" [title]="customMsgService.translate('name')">
                </kendo-grid-column>    
                <kendo-grid-column field="descricaoTamanho" [title]="customMsgService.translate('size')">
                </kendo-grid-column>   
    
                <kendo-grid-column field="avariasDesccricao" [title]="customMsgService.translate('listaDeAvarias')"
                    >
                </kendo-grid-column>
                <kendo-grid-column field="obs" [title]="customMsgService.translate('obs')">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('tooltypes')}}.xlsx">
            </kendo-grid-excel>
            
        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>